module.exports = __webpack_public_path__ + "static/media/symbol_new_folder.c1652ab7.svg";